import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import FooterOne from "../../components/Footer/FooterOne";
import DataFetcher from "../../components/DataFetcher/DataFetcher";

const MarketReportList = () => {
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}?op=reports`;
  
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <Loader>
      <HeaderOne />
      <section className="white-bg">
        <div className="container my-5">
          <h2>Olshan Luxury Market Report - Archive</h2>
        </div>
        <br />
        <div className="container">
          <DataFetcher url={API_URL}>
            {(data) => (
              <div className="row">
                {data.map((item) => (
                  <div className="col-md-4 mb-3" key={item.ReportId}>
                    <a
                      href={`market-report-archive/${item.ReportId}`}
                      rel="noopener noreferrer"
                      className="d-block p-3 border rounded text-decoration-none h-100"
                    >
                      {item.ReportName}
                    </a>
                  </div>
                ))}
              </div>
            )}
          </DataFetcher>
        </div>
      </section>
      <FooterOne />
    </Loader>
  );
};

export default MarketReportList;
